import { useEffect } from 'react';
export function useSectionsInView({ ids, onActive }) {
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const firstIntersection = entries.find((entry) => entry.isIntersecting);
            if (!firstIntersection) {
                // Ignore, usually means something left the viewport.
                return;
            }
            const id = firstIntersection.target.dataset.anchorNavId;
            if (!id) {
                console.warn(`Could not determine ID of observed element.`);
                return;
            }
            // Ensure active item is highlighted.
            onActive(id);
        }, {
            // Account for fixed header and anchor nav when determining which section is "in view"
            rootMargin: '-15% 0% -50% 0%',
        });
        const elements = document.querySelectorAll(ids
            .filter(Boolean)
            .map((id) => `[data-anchor-nav-id="${id}"]`)
            .join(', '));
        elements.forEach((element) => {
            observer.observe(element);
        });
        return () => {
            observer.disconnect();
        };
    }, ids);
}
